// extracted by mini-css-extract-plugin
export default {"link":"postSectionHeader-module__link___iC7QI","icon":"postSectionHeader-module__icon___jd0Dl"};